<template>
<div class="container">
    <div class="row">
        <div class="ProductCard_outline col-lg-3 col-md-4 col-sm-6 col-xs-12" v-for= "product in products">
            <div class="ProductCard " >
                <div class="ProduCard_tag">{{product.tag}}</div>
                <div class="ProductCard_img">
                    <img :src="product.img" alt="">
                </div>
                <div class="ProductCard_describe">
                    <div class="ProductCard_describe_title">{{product.title}}</div>
                    <div class="ProductCard_describe_intro">{{product.describe}}</div>    
                    <div class="ProductCard_describe_price">NT {{product.price}}</div>
                    <div class="ProductCard_describe_purchase">
                        <button class="purchase" @click="PushtoCart(product)">加入購物車</button>
                    </div>
                    
                </div>
            </div>
        </div>
    </div>
</div>
</template>

<script>
import { mapState, mapMutations, mapActions} from 'vuex'
export default {
    props:["products"],
    methods:{
        ...mapActions('cart',['PushtoCart'])   
    }
}
</script>
<style lang="sass">
$MainColor: #FFCBBB
$DarkMainColor: #b25437
@mixin FlexSetting($justify-content:center, $align-items:center)
	display: flex
	justify-content: $justify-content
	align-items: $align-items
.container
    margin-top: 60px
    padding: 20px 40px
.ProductCard_outline
    margin-bottom: 10px 
.ProductCard 
    padding: 10px
    box-shadow: 2px 2px 10px rgba(#ccc,0.5)
    .ProduCard_tag
        position: absolute            
        z-index: 5
        top: 5%
        padding: 10px
        color: #fff
        letter-spacing: 5px
        background-color: rgba($DarkMainColor,0.8)
        box-shadow: 5px 5px 10px rgba(#000,0.5)
    .ProductCard_img
        position: relative
        height: 180px
        img
            display: block
            margin: auto
            width: auto
            height: auto
            max-width: 100%
            max-height: 100%
    .ProductCard_describe
        +FlexSetting(flex-start,flex-start)
        flex-direction: column
        width: 100%
        height: 100%
        text-align: left
        padding: 5px
        line-height: 32px
        letter-spacing: 3px 
        .ProductCard_describe_intro
            font-size: 14px
            letter-spacing: 1px
        .ProductCard_describe_price
            +FlexSetting(space-between, center)
            width: 100%
        .ProductCard_describe_purchase
            +FlexSetting
            width: 100%
            padding: 10px
            .purchase
                border: 0
                padding: 2px 10px 
                background-color: #fff
                width: 100%
                border: 1px solid $DarkMainColor
                &:hover
                    background-color: $DarkMainColor
                    color: #fff
                    cursor: pointer
</style>



// WEBPACK FOOTER //
// src/components/ProductCard.vue